const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAyQzIxLjEwNDYgMiAyMiAyLjg5NTQzIDIyIDRWMjBDMjIgMjEuMTA0NiAyMS4xMDQ2IDIyIDIwIDIySDRDMi44OTU0MyAyMiAyIDIxLjEwNDYgMiAyMFY0QzIgMi44OTU0MyAyLjg5NTQzIDIgNCAySDIwWk0yMCA0SDRWMjBIMjBWNFoiLz4KPC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=stop-95b94b3d.mjs.map
